export default __webpack_public_path__ + "static/media/youtube.993e445d.svg";